import {css, keyframes} from '@emotion/css';
import {Breakpoints, mq} from '@fo/shared/styles/mixins';
import {coloursV2, lighten, fonts, spacing} from '@fo/shared/styles/variables';

import {LoginStep} from './types';

export default {
  container: css`
    label: loginModalInTwoSteps__container;
    display: grid;
    grid-template-columns: [content-start] 1fr [content-end];
    ${mq(Breakpoints.TABLET)} {
      grid-template-columns: 1fr [content-start] 48rem [content-end] 1fr;
    }

    & > * {
      grid-column: content;
    }
  `,
  titleContainer: css`
    label: loginModalInTwoSteps__titleContainer;
    display: grid;
    grid-template-columns: [title-icon-start] 2.4rem [title-icon-end title-start] 1fr [title-end] 2.4rem;
    align-items: center;
    margin: ${spacing.XS} 0;

    & svg {
      opacity: 0.5;
      animation: ${keyframes`
      0% {
        transform: scale(0) rotate(-180deg);
      }

      100% {
        transform: scale(1) rotate(-180deg);
      }
  `} 100ms ease-out;
    }

    ${mq(Breakpoints.TABLET)} {
      margin: 0 0 ${spacing.S};
    }
  `,
  backButton: css`
    label: loginModalOnTwoSteps__backButton;
    padding: 0;
  `,
  title: css`
    label: loginModalOnTwoSteps__title;
    grid-column: title;
    text-align: center;
    font-size: ${fonts.size.H3};
  `,
  formStepsContainer: css`
    label: loginModalOnTwoSteps__formStepsContainer;
    width: 100%;
    overflow: hidden;
  `,
  formStepsContainerSlider: (loginStep: LoginStep): string => css`
    label: loginModalOnTwoSteps__formStepsContainerSlider;
    display: flex;
    width: 200%;
    transition: margin-left 250ms ease-in-out;
    & > div {
      width: 50%;
    }
    ${loginStep === LoginStep.PASSWORD &&
    css`
      margin-left: -100%;
    `}
  `,
  tideUserSeparator: css`
    label: loginModalOnTwoSteps__tideUserSeparator;
    display: flex;
    align-items: center;
    gap: ${spacing.XXS};
    margin: ${spacing.XS} 0;
    color: ${coloursV2.generic.grey};
  `,
  tideUserSeparatorDashes: css`
    label: loginModalOnTwoSteps__tideUserSeparatorDashes;
    flex-grow: 1;
    height: 1px;
    background: linear-gradient(
      to right,
      ${lighten(coloursV2.generic.grey)} 0%,
      ${lighten(coloursV2.generic.grey)} 33%,
      transparent 33%,
      transparent 66%,
      ${lighten(coloursV2.generic.grey)} 66%,
      ${lighten(coloursV2.generic.grey)} 100%
    );
    background-size: 20px 1px;
  `,
  tideUserSubtitle: css`
    label: loginModalOnTwoSteps__advisorAccessSubtitle;
    color: ${coloursV2.brand.secondary};
    font-weight: ${fonts.weight.SEMI_BOLD};
    margin-bottom: ${spacing.XS};
  `,
};
